// The home screen of an event-day job device (card 540f21a4): which event and
// job this device is for, and the screens that job includes. Leaving device
// mode (after a confirm) forgets the device here; the organizer can also
// revoke it from the Job devices screen.
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { SET_MODAL } from '../redux/actionTypes/modalActionType';
import AddCompetitorModal from '../Components/Modals/OrganizerModel/ManageFeis/Entries/AddCompetitorModal';
import AddedCompetitor from '../Components/Modals/OrganizerModel/ManageFeis/Entries/AddedCompetitorModal';
import '../Teacher/Oireachtas/oireachtas.css';
import '../Organizer/Oireachtas/organizerOireachtas.css';
import './deviceHome.css';
import { Msr, useMaterialSymbols } from '../Teacher/Oireachtas/components';
import { useJobDevice } from './DeviceContext';
import { forgetDevice } from './deviceSession';
import { FEIS_SCREENS, screenLink } from './deviceScreens';

export default function DeviceHome() {
  useMaterialSymbols();
  const { device, me, can } = useJobDevice();
  const [confirmLeave, setConfirmLeave] = useState(false);
  const dispatch = useDispatch();
  const modal = useSelector((state) => state.modalReducer) || {};
  // the Add a Competitor window closes if the job loses it (MC review 0699f116 R1-F5)
  const canAdd = !!me && can('feis.competitors.edit');
  const addOpen = modal.modal === 'AddCompetitor' || modal.modal === 'AddedCompetitor';
  useEffect(() => {
    if (addOpen && me && !canAdd) dispatch({ type: SET_MODAL, payload: { modal: '', eventProp: '' } });
  }, [addOpen, canAdd, me, dispatch]);
  if (!device) return null;
  const event = { _id: device.eventId, name: me?.event?.name || device.eventName };
  const screens = me ? FEIS_SCREENS.filter((s) => can(...s.any)) : [];

  // the organizer's Add a Competitor window, for this device's feis
  const openModal = (name) => {
    try {
      localStorage.setItem('Manage', 'feis');
    } catch (e) {
      // the window reads it; without storage it adds as a feis anyway
    }
    dispatch({ type: SET_MODAL, payload: { modal: name, eventId: device.eventId } });
  };

  const leave = () => {
    forgetDevice();
    window.location.replace('/device');
  };

  return (
    <div className="oir dh-page">
      <div className="wrap">
        <header className="dh-head">
          <div>
            <div className="dh-event">{event.name || 'Event'}</div>
            <div className="dh-job">
              <Msr>badge</Msr> {device.roleName}
              {device.label ? <span className="dh-label"> · {device.label}</span> : null}
            </div>
          </div>
          {confirmLeave ? (
            <div className="dh-leave">
              <span>Stop using this device for the event?</span>
              <button type="button" className="op-btn sm danger" onClick={leave}>
                Stop
              </button>
              <button type="button" className="op-btn sm" onClick={() => setConfirmLeave(false)}>
                Keep
              </button>
            </div>
          ) : (
            <button type="button" className="op-btn sm" onClick={() => setConfirmLeave(true)}>
              <Msr>logout</Msr> Leave device mode
            </button>
          )}
        </header>

        {!me ? (
          <p className="dh-wait">Loading this device's job…</p>
        ) : screens.length ? (
          <div className="dh-grid">
            {screens.map((s) =>
              s.modal ? (
                <button key={s.key} type="button" className="dh-card" onClick={() => openModal(s.modal)}>
                  <Msr>{s.icon}</Msr>
                  <span className="dh-title">{s.title}</span>
                  <span className="dh-desc">{s.description}</span>
                </button>
              ) : (
                <Link key={s.key} className="dh-card" to={screenLink(s, event)} state={{ eventName: event.name }}>
                  <Msr>{s.icon}</Msr>
                  <span className="dh-title">{s.title}</span>
                  <span className="dh-desc">{s.description}</span>
                </Link>
              )
            )}
          </div>
        ) : (
          <p className="dh-wait">This device's job has no screens yet. Ask the organizer.</p>
        )}
        {canAdd && modal.modal === 'AddCompetitor' && <AddCompetitorModal modalState={true} />}
        {canAdd && modal.modal === 'AddedCompetitor' && <AddedCompetitor modalState={true} />}
      </div>
    </div>
  );
}
